import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ProgressBar, ProgressValue, ProgressWrap } from 'olive-react-myoneui';
import { deadlineIcon, playBlueIcon, rightArrowLong } from '../../../constants/icons';
import { styled } from '@mui/material/styles';
import Form from 'olive-react-myoneui/lib/Form';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import ModalCommon from '../ModalCommon';
import Rating from '@mui/material/Rating';
import { addDays, format, parseISO } from "date-fns";
import Button from "olive-react-myoneui/lib/Button";
import Skeleton from 'react-loading-skeleton';
import { postCourseReview } from '../../../../api/afterLogin/courses';

export default function IntroCard(props) {
  const { slug, id, title, imgSrc, subTitle, initialRating, className, progressPercentage, showRating, isSelfRated, validityAccessType, validityByDays, validityByDate, courseDate, courseStatus, courseStartLink, courseResumeLink, isLoading, render, archive = null, enrollmentDate = null, completionDate = null, certificateStatus = null, certificateValidity = null, isCertificateOnlyArchived = null, isCourse, asRatingUpdate, overallRating, reviews, onPlayBtnClick, deadlineText, hasResumeCourse, isApprenticeResumeCourse, apprenticeUrl, accessMykademy, accessEportfolio, isBundle} = props;
  const [validated, setValidated] = useState(false);
  const [reviewDesc, setreviewDesc] = useState('');
  const [postRating, setPostRating] = useState(0);
  const [errorRating, setErrorRating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showThankModal, setShowThankModel] = useState(false);
  const [showMessage, setShowMessage] = useState('');
  const maxDescLength = 1000;
  const paths = useSelector((state) => state.user.paths);
  const configData = useSelector((state) => state.config);
  const defaultImg = paths.default_course;
  const navigate = useNavigate();

  const StyledRating = styled(Rating)({
    '& .MuiRating-icon': {
      color: '#a4a4a4',
    },
    '& .MuiRating-iconFilled': {
      color: '#f8c068',
    },
    '& .MuiRating-iconHover': {
      color: '#f8c068',
    },
  });

  const deadlineDate = validityAccessType === '0' ? 'Lifetime Validity' :
                      courseDate ? 'Deadline : ' + format(parseISO(courseDate), 'MMM d, yyyy') :
                      'Lifetime Validity';
  const isExternalLink = (url) => {
    try {
        const link = new URL(url);
        return link.protocol === "http:" || link.protocol === "https:";
    } catch (e) {
        return false;
    }
  };
  const startClickHandler = (link, event) => {
    event.preventDefault();
    if (link === '') return false;
    window.location.replace(link)
  };

  const detailClickHandler = (link, event) => {
    event.preventDefault();
    if (isExternalLink(link)) {
      window.location.replace(link);
    } else {
      navigate('/student-dashboard/courses/detail/' + link);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowThankModel(false);
    setShowMessage('');
  }

  const handleShowModal = () => {
    if (!archive) setShowModal(true)
  };

  const handleSelfModal = () => {
    setShowThankModel(true);
    setShowMessage("You've already rated this course");
  };

  const handleDescChange = (e) => {
    if (e.target.value.length <= maxDescLength) {
        setreviewDesc(e.target.value);
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault(); 
    const form = event.currentTarget;
  
    if (form.checkValidity() === false && postRating === 0) {
      setErrorRating(true);
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }
    if (reviewDesc === '') {
      setValidated(true);
      return;
    }
    const postParams = {
      course_id: id,
      rating: postRating ?? 0,
      review: reviewDesc
    };

    if (postParams.rating === 0) {
      setErrorRating(true);
      return;
    }

    const response = await postCourseReview(configData.access_token, postParams);

    if (response) {
      setShowModal(false);
      setShowThankModel(true);
      setShowMessage(response.status === 200 ? 'Review submitted successfully' : 'Review submission failed');
      if (response.status === 200) {
        asRatingUpdate();
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
      return 'N/A';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'N/A';
    }
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  };

  return (
    <>
    {isLoading === false && render === true ? (
    <div className={`intro-card-wrapper ${className || ''}`}>
      {title && <h2>{title}</h2>}
      <div className="intro-card-holder">
        <div className="intro-card">
          <img
            loading="lazy"
            src={imgSrc}
            onError={(e) => (e.target.src = defaultImg)}
            alt="Resume learning"
            onClick={slug && slug !== '' ? (e) => detailClickHandler(slug, e) : null}
            className={slug && slug !== '' ? 'cursor-pointer' : ''}
          />
          <img
            className="image-shadow"
            loading="lazy"
            src={imgSrc}
            onError={(e) => (e.target.src = defaultImg)}
            alt="Resume learning"
          />
          {onPlayBtnClick &&
            <span
              role="button"
              className="play-icon"
              onClick={onPlayBtnClick}
            >
              {playBlueIcon}
            </span>
          }
        </div>
        <div className={`intro-card-info ${archive ? 'myk_archive_info':''}`}>
          <div className="myk__course-deadline_ratings">
            {archive &&(
               <div className="intro-card-date">
               <div className="date-label">Enrollment Date:</div>
               <div className="date-value">{enrollmentDate ? formatDate(enrollmentDate) : "N/A"}</div>
             </div>
            )}
            {archive && (
              <div className="intro-card-date">
                <div className="date-label">Completion Date:</div>
                <div className="date-value">
                  {completionDate ? formatDate(completionDate) : "N/A"}
                </div>
              </div>
            )}
            {archive && certificateStatus && (
               <div className="intro-card-date">
               <div className="date-label">Certificate Status:</div>
               <div className="date-value">{certificateStatus}</div>
             </div>
            )}
            {archive && certificateStatus && (
               <div className="intro-card-date">
               <div className="date-label">Certificate Validity:</div>
               <div className="date-value">
               {certificateValidity === null || certificateValidity === "" 
                ? "N/A" 
                : certificateValidity === "unlimited" 
                ? "Unlimited" 
                : formatDate(certificateValidity)}
               </div>
             </div>
            )}
            {isCourse && (
              <div className="intro-card-date">
                {validityAccessType === '0' && <div className="date-label">Course Validity:</div>}
                <div className="date-value">  {deadlineDate}</div>
            </div>
            )}
            {!hasResumeCourse && isApprenticeResumeCourse && (
              <div className="intro-card-date">
                <div className="date-value">  {deadlineText}</div>
              </div>
            )}
            {hasResumeCourse && (
              <div className="intro-card-date">
                <div className="date-value">  {deadlineDate}</div>
            </div>
            )}
            {archive && (  
             <div className="intro-card-date">
               <div className="date-label">Course Validity:</div>
               <div className="date-value">  {archive ? "Expired" : formatDate(certificateValidity)}</div>
             </div>
            )}
            {showRating &&
              <div className="myk__stu-rating d-flex align-items-center gap-2" onClick={isSelfRated ? handleSelfModal : handleShowModal}>
                <div className="rating-label">Rate:</div>
                 <StyledRating name="half-rating" defaultValue={overallRating} precision={0.5} size="small" disabled/>
              </div>
            }
          </div>
          {subTitle && <h4 title={subTitle} onClick={slug && slug !== '' ? (e) => detailClickHandler(slug, e) : null} className={slug && slug !== '' ? 'cursor-pointer' : ''}>{subTitle}</h4>}
          
          {(!archive || (archive && isCertificateOnlyArchived == 0)) && (
            <ProgressWrap className="myk__stu-course-progress_bar">
              <ProgressBar variant="success" now={progressPercentage} />
              <ProgressValue ProgressPercentage={`${progressPercentage}%`} />
            </ProgressWrap>
          )}

          {courseStatus === "inprogress" && (
            <Button
              variant="outline"
              className="btn-round mt-2 bg-transparent text-white border-white btn-resume"
              size="sm"
              onClick={(e) => startClickHandler(courseResumeLink,e)}
            >
              Resume Learning {rightArrowLong}
            </Button>
          )}

          {courseStatus === "not-started" && (
            <Button
              variant="outline"
              className="btn-round mt-2 bg-transparent text-white border-white"
              size="sm"
              onClick={(e) => startClickHandler(courseStartLink,e)}
            >
              Start Learning {rightArrowLong}
            </Button>
          )}
        </div>
      </div>
    </div>
    ) : (isLoading === false && render === false) ? (
    <div class="empty-intro-card-wrapper myk__stu-explore-course-block">
      <div class="text-center empty-block-wrapper card-body">
        <div class="empty-block">
          {accessMykademy && accessEportfolio && (
            <>
            <h6><strong>Service Provider are currently disabled!</strong></h6>
            <p>please contact administrator.</p>
            </>
          )}
          {!accessMykademy && (
            <>
            <h6><strong>Let’s begin learning!</strong></h6>
            <p>When you enroll in a course, it will appear here.</p>
            <Button variant="secondary" onClick={(e) => startClickHandler('/course/listing',e)}>Explore courses</Button>
            </>
          )}
          {accessMykademy && !accessEportfolio && (
            <>
            <h6><strong>Let’s begin learning!</strong></h6>
            <p>When you enroll in a course, it will appear here.</p>
            </>
          )}
        </div>
      </div>
    </div>
    ) : (
    <div className="empty-intro-card-wrapper">
      <h2><Skeleton width={"33%"} height={"26px"}/></h2>
      <div className="intro-card-holder">
        <div className="empty-intro-card">
          <Skeleton borderRadius={"1.25rem"} width={"272.655px"} height={"193.086px"}/>
        </div>
        <div className="intro-card-info">
          <Skeleton width={"48%"} height={"13px"} />
          <Skeleton width={"48%"} height={"20px"} />
          <br/>
          <h4><Skeleton height={"8px"}/></h4>
        </div>
      </div>
    </div>
    )}
    <ModalCommon
      show={showModal}
      onClose={handleCloseModal}
      title="Leave a Review"
      className="myk__stu-question-modal"
      >
        <div className="text-start">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formGroupReviewDesc">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        as="textarea"
                        placeholder="Type your review"
                        style={{ height: '100px' }}
                        maxLength={maxDescLength}
                        onChange={handleDescChange}
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                    Please provide your review.
                    </Form.Control.Feedback>
                    <p className="mt-2 text-gray text-end">Total: {reviewDesc.length}/{maxDescLength} characters</p>
                </Form.Group>
                <Row>
                  <Col>
                      <div className="myk__stu-rating myk__stu-rating-modal d-flex align-items-center gap-2">
                        <div className="rating-label">Rate:</div>
                        <StyledRating name="half-rating" defaultValue={postRating} precision={1} size="small" onChange={(event, newValue) => {setErrorRating(false);setPostRating(newValue)}} />
                        <p style={{color: 'red'}}><small>{errorRating && 'Please select a rating.'}</small></p> 
                      </div>
                  </Col>
                </Row>
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={handleCloseModal}>Cancel</Button>
                        <Button variant="primary" type="submit">Post Review</Button>
                    </Col>
                </Row>
            </Form>
        </div>
      </ModalCommon>

      <ModalCommon
        show={showThankModal}
        onClose={handleCloseModal}
        title=""
        className="myk__stu-question-modal"
        >
        <div className="text-start">
          <Row>
            <Col>
                <div className="myk__stu-rating myk__stu-rating-modal d-flex align-items-center gap-2">
                  <p>{showMessage}</p> 
                </div>
            </Col>
          </Row>
          <Row>
              <Col className="text-end mt-3">
                  <Button variant="primary" onClick={handleCloseModal}>OK</Button>
              </Col>
          </Row>
        </div>
      </ModalCommon>
    </>
  );
}
